import React, { Component } from 'react';
import Slider from 'react-slick';

export class AsNavFor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null,
      imageZoomed: this.props.isZoomed,
    };
    this.moveToSelectedSwatchOnImgSwipe = this.moveToSelectedSwatchOnImgSwipe.bind(this);
  }
  componentDidMount() {
    this.setState({ nav1: this.slider1, nav2: this.slider2 });
  }
  moveToSelectedSwatchOnImgSwipe(index) {
    this.props.passedFunctions.updateAttributeFromAltSwipe(index);
  }
  mainImageClick = (event) => {
    this.state.imageZoomed == false ? this.props.mainImageClicked() : this.props.zoomedImageClose();
  };
  render() {
    var altImagesToUse = JSON.parse(JSON.stringify(this.props.contentData.altImages || []));
    if (typeof window != 'undefined' && window.injectedAltImageFunction) {
      altImagesToUse = window.injectedAltImageFunction(
        altImagesToUse,
        this.props.passedFunctions.parentState.selectedMainImg
      );
    }

    const settings = {
      swipeToSlide: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 1350,
          settings: {
            slidesToShow: 8.5,
          },
        },
        {
          breakpoint: 1150,
          settings: {
            slidesToShow: 7.5,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 6.5,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 5.5,
          },
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 4.5,
          },
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 3.5,
          },
        },
      ],

      afterChange: (index) => {
        this.moveToSelectedSwatchOnImgSwipe(index);
      },
    };
    if (this.props.selectedMainImg && this.slider1 && altImagesToUse) {
      for (var i = 0; i < altImagesToUse.length; i++) {
        if (altImagesToUse[i].imageName === this.props.selectedMainImg) {
          this.slider1.slickGoTo(i);
        }
      }
    }

    return (
      <div>
        <Slider asNavFor={this.state.nav2} infinite={false} ref={(slider) => (this.slider1 = slider)}>
          {(altImagesToUse || []).map((altImage, index) => (
            <div key={altImage.imageName + '__' + index}>
              {this.state.imageZoomed == false ? (
                <div onClick={this.mainImageClick}>
                  <img
                    src={`//dimg.dillards.com/is/image/DillardsZoom/main/${this.props.contentData.fullImage.imageNameForUrl}/${altImage.overideImageName || altImage.imageName}.jpg`}
                    data-imagename={altImage.imageName}
                    alt={altImage.altText}
                  />
                </div>
              ) : (
                <img
                  src={`//dimg.dillards.com/is/image/DillardsZoom/main/${this.props.contentData.fullImage.imageNameForUrl}/${altImage.overideImageName || altImage.imageName}.jpg`}
                  data-imagename={altImage.imageName}
                  alt={altImage.altText}
                />
              )}
            </div>
          ))}
        </Slider>
        <span className='tapToZoom'>Tap Image to Zoom</span>
        <div className='altContainer'>
          <Slider asNavFor={this.state.nav1} ref={(slider) => (this.slider2 = slider)} {...settings}>
            {(altImagesToUse || []).map((altImage, index) => (
              <div key={altImage.imageName + '__' + index}>
                <img
                  src={`//dimg.dillards.com/is/image/DillardsZoom/alt/${this.props.contentData.fullImage.imageNameForUrl}/${altImage.overideImageName || altImage.imageName}.jpg`}
                  alt={altImage.altText}
                  data-imagename={altImage.imageName}
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}
